// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_customer_button-module__container--2AFkv"};